import ShowcaseContactLogsTypes from 'store/actionTypes/showcaseContactLogs'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  components: {
    list: [],
    pagination: {}
  },
  exportData: {}
}

const showcaseContactLog = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ShowcaseContactLogsTypes.GET_SHOWCASE_LOGS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case ShowcaseContactLogsTypes.UPDATE_FILTER_SHOWCASE_LOG_SUCCESS:
      return { ...state, filter: payload }
    case ShowcaseContactLogsTypes.CLEAR_FILTER_SHOWCASE_LOG_SUCCESS:
      return { ...state, filter: initialData.filter }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    case ShowcaseContactLogsTypes.EXPORT_SHOWCASE_CONTACT_LOG_SUCCESS:
      return {
        ...state,
        exportData: { data: payload, responseHeaders: action.responseHeaders }
      }
    default:
      return state
  }
}

export default showcaseContactLog
